import { createSlice } from "@reduxjs/toolkit";
const initialState = {};
const slice = createSlice({
    name: "bp",
    initialState,
    reducers: {
        setProfileOptions: (state, action) => {
            state.profileOptions = action.payload;
        },
        setDefaultProfileId: (state, action) => {
            state.defaultProfileId = action.payload;
        },
        setSelectedProfileId: (state, action) => {
            state.selectedProfileId = action.payload;
        },
    },
});
export const { setProfileOptions, setDefaultProfileId, setSelectedProfileId } = slice.actions;
export * from "./selectors";
export default slice.reducer;
